import { createApp } from 'vue'
import App from './App.vue'

import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/css/common.less'
// import router from '@/router'

window.url = 'http://192.168.50.69:8080/';
// window.url1 = 'http://192.168.50.71:8060/';
window.url1 = 'https://www.paipiaochajiang.com:8020/';

const app = createApp(App)
// app.use(router)
app.use(Vant).mount('#app')
